import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import "../styles/OrdersTrendChart.css";

const OrdersTrendChartZomato = ({selectedRestData}) => {

  // const data = [
  //   { month: "2025-07", newOrders: 150, repeatOrders: 260 },
  //   { month: "2025-08", newOrders: 140, repeatOrders: 280 },
  //   { month: "2025-09", newOrders: 170, repeatOrders: 300 },
  //   { month: "2025-10", newOrders: 190, repeatOrders: 340 },
  //   { month: "2025-11", newOrders: 190, repeatOrders: 340 },
  //   { month: "2025-12", newOrders: 190, repeatOrders: 340 }
  // ];



  const filteredData = selectedRestData?.filter(item => {
    const newUsers = Number(item.new_users) || 0;
    const repeatUsers = Number(item.repeat_users) || 0;
    return newUsers > 0 || repeatUsers > 0;
  });


  
  return (
    <div className="glass-card">

      <h4 className="chart-title">Orders Trend</h4>

      <ResponsiveContainer width="100%" height={320}>
        <BarChart data={filteredData}>
          <XAxis dataKey="period" />
          <YAxis />
          <Tooltip />
          <Legend />

          <Bar dataKey="new_users" name="New User Orders" fill="#4CAF50" />
          <Bar dataKey="repeat_users" name="Repeat User Orders" fill="#FF9800" />

        </BarChart>
      </ResponsiveContainer>

    </div>
  );
};

export default OrdersTrendChartZomato;